import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import arrowNext from "assets/icons/Arrow Next.svg";
import arrowPrev from "assets/icons/Arrow Prev.svg";

import moment from "jalali-moment";
import priceSeprator from "utils/priceSeparator/PriceSeparator";

import PageCounter from "components/pageCounter/PageCounter";

import {
  Tbody,
  Paginate,
  Container,
  TableContainer,
  TableHeader,
  TableRowCard,
  Nodata,
} from "./TransactionTable.styled";
import { trackPromise } from "react-promise-tracker";
import Transactions from "services/apis/transactionsAPI";
import rialConvertToToman from "utils/convertRialToToman/convertRialToToman";

function TransactionTable({ handleNoData }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(5);
  const [tableData, setTableData] = useState(null);
  const [numberOfPages2, setNumberOfPages2] = useState(0);

  async function getTableData() {
    const requestParams = {
      count: dataPerPage,
      page: currentPage,
    };

    const response = await new Transactions().getTransactions(requestParams);

    if (response.data.data.rows.length === 0) {
      handleNoData(true);
    }
    setTableData(response.data.data);
    setTableData(response.data.data);
    let tempNumberOfPages = [...arrOfCurrButtons];
    let dotsInitial = "...";
    let dotsLeft = "... ";
    let dotsRight = " ...";

    const numberOfPages = [
      ...Array(Math.ceil(response.data.data.count / dataPerPage) + 1).keys(),
    ].slice(1);

    setNumberOfPages2(numberOfPages);

    if (numberOfPages.length < 6) {
      tempNumberOfPages = numberOfPages;
    } else if (currentPage >= 1 && currentPage <= 3) {
      tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
    } else if (currentPage === 4) {
      const sliced = numberOfPages.slice(0, 5);
      tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
    } else if (currentPage > 4 && currentPage < numberOfPages.length - 2) {
      // from 5 to 8 -> (10 - 2)
      const sliced1 = numberOfPages.slice(currentPage - 2, currentPage); // sliced1 (5-2, 5) -> [4,5]
      const sliced2 = numberOfPages.slice(currentPage, currentPage + 1); // sliced1 (5, 5+1) -> [6]
      tempNumberOfPages = [
        1,
        dotsLeft,
        ...sliced1,
        ...sliced2,
        dotsRight,
        numberOfPages.length,
      ]; // [1, '...', 4, 5, 6, '...', 10]
    } else if (currentPage > numberOfPages.length - 3) {
      // > 7
      const sliced = numberOfPages.slice(numberOfPages.length - 4); // slice(10-4)
      tempNumberOfPages = [1, dotsLeft, ...sliced];
    } else if (currentPage === dotsInitial) {
      // [1, 2, 3, 4, "...", 10].length = 6 - 3  = 3
      // arrOfCurrButtons[3] = 4 + 1 = 5
      // or
      // [1, 2, 3, 4, 5, "...", 10].length = 7 - 3 = 4
      // [1, 2, 3, 4, 5, "...", 10][4] = 5 + 1 = 6
      setCurrentPage(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
    } else if (currentPage === dotsRight) {
      setCurrentPage(arrOfCurrButtons[3] + 2);
    } else if (currentPage === dotsLeft) {
      setCurrentPage(arrOfCurrButtons[3] - 2);
    }
    setArrOfCurrButtons(tempNumberOfPages);
    setCurrentPage(currentPage);
  }

  useEffect(() => {
    // trackPromise(
    getTableData();
    // )
  }, [currentPage, dataPerPage]);

  // get Table Data>

  let lastIndex = currentPage * dataPerPage - (dataPerPage - 1);

  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  return (
    <Container>
      <TableContainer>
        {tableData ? (
          <>
            <TableHeader>
              <div>ردیف</div>
              <div>عملیات</div>
              <div>مبلغ (تومان)</div>
              <div>تاریخ</div>
              <div>نتیجه ی تراکنش</div>
              <div>موجودی (تومان)</div>
              {/* <div>حذف</div> */}
            </TableHeader>
            <Tbody>
              {tableData &&
                tableData.rows.map((row, index) => {
                  return <TableRow row={row} index={lastIndex++} key={index} />;
                })}
            </Tbody>
          </>
        ) : (
          <h4>هیچ تراکنشی وجود ندارد</h4>
        )}
      </TableContainer>
      {tableData && (
        <Paginate>
          <ul>
            <PageCounter
              active={numberOfPages2.length !== currentPage ? true : false}
              dataPerPageCounter={(num) => setDataPerPage(num)}
            />
            <li>
              <a
                href="#"
                className={`${currentPage === 1 ? "disabled" : ""}`}
                onClick={() =>
                  setCurrentPage((prev) => (prev <= 1 ? prev : prev - 1))
                }
              >
                <img src={arrowPrev} alt="arrow prev" className="arrowPrev" />
                <span>قبلی</span>
              </a>
            </li>

            {arrOfCurrButtons.map((item, index) => {
              return (
                <li>
                  <a
                    href="#"
                    key={index}
                    className={`${currentPage === item ? "active" : ""}`}
                    onClick={() => setCurrentPage(item)}
                  >
                    {item}
                  </a>
                </li>
              );
            })}
            <li>
              <a
                href="#"
                className={`${
                  currentPage === numberOfPages2.length ? "disabled" : ""
                }`}
                onClick={() =>
                  setCurrentPage((prev) =>
                    prev >= numberOfPages2.length ? prev : prev + 1
                  )
                }
              >
                <span>بعدی</span>
                <img src={arrowNext} alt="arrow prev" className="arrowNext" />
              </a>
            </li>
          </ul>
        </Paginate>
      )}
    </Container>
  );
}

function TableRow({ row, index }) {
  // <use Navigation
  const navigate = useNavigate();
  // use Navigation>

  const [date, setDate] = useState("");

  const formateDate = () => {
    const onlyDay =
      row.createdAt.substring(0, row.createdAt.lastIndexOf("T")) ||
      row.createdAt;
    const ready = onlyDay.replace(/[-]/g, "/");
    const mo = moment(ready, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
    return moment(ready, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
  };

  // <transaction type convertor
  const [type, setType] = useState("-");

  function typeConvertor() {
    const type = row.type;
    switch (type) {
      case "withdrawal":
        setType("هزینه استفاده");
        break;
      case "deposited":
        setType("واریز");
        break;
      case "return":
        setType("برگشتی");
        break;
      case "gift":
        setType("کد هدیه");
        break;
      default:
        break;
    }
  }
  // transaction type convertor>

  // <transaction result convertor

  function resultConvertor() {
    if (row.isPending === true && row.isSuccessful === null) {
      return "در حال انجام";
    } else if (row.isPending === false && row.isSuccessful === true) {
      return "موفق";
    } else if (row.isPending === false && row.isSuccessful === false) {
      return "ناموفق";
    } else if (!row.isPending && row.isSuccessful === null) {
      return "انصراف";
    } else if (row.isPending === true && row.isSuccessful === true) {
      return "ناموفق";
    }
  }

  // transaction result convertor>

  useEffect(() => {
    typeConvertor();
  }, [row.type]);

  return (
    <TableRowCard>
      <div>{index}.</div>
      <div>{type}</div>
      <div>
        {priceSeprator(rialConvertToToman(Math.abs(row.amount))) ?? "-"}
      </div>
      <div>{formateDate()}</div>
      <div>{resultConvertor()}</div>
      <div>
        {priceSeprator(rialConvertToToman(row.lastBalance).toFixed(0)) ?? "-"}
      </div>
    </TableRowCard>
  );
}
export default TransactionTable;
